import { jsx as r, jsxs as t } from "react/jsx-runtime";
import { Alert as F, Flex as l, chakra as I } from "@chakra-ui/react";
import { useMemo as i } from "react";
import { getAlertTextColor as V, getAlertBackgroundColor as k, getAlertIcon as M } from "./helper.js";
import { ThemeFontVariable as m, ThemeRadiusVariable as j, ThemeSpaceVariable as B, ThemeIconSizeVariable as s, ThemeFontSizeVariable as w } from "../../theme/theme-types.js";
import { Icon as f } from "../icon/icon.js";
import { Text as R } from "../text/text.js";
import { Icons as y } from "../icon/types.js";
function G({
  minHeight: d = "48px",
  px: u = B.Medium,
  py: x = "12px",
  w: g = "100%",
  children: p,
  title: o,
  onClose: a,
  type: e = "info",
  iconVerticalAlign: b,
  icon: h,
  ...C
}) {
  const n = i(() => V(e), [e]), S = i(() => k(e), [e]), T = h ?? i(() => M(e), [e]), A = () => a ? /* @__PURE__ */ r(
    I.button,
    {
      type: "button",
      "aria-label": "Close",
      onClick: a,
      mt: o ? "4px" : 0,
      alignSelf: o ? "flex-start" : "center",
      children: /* @__PURE__ */ r(f, { icon: y.Close, size: s.Medium, color: n })
    }
  ) : null, c = b || (o ? "flex-start" : "center"), z = c === "flex-start" ? "4px" : 0;
  return /* @__PURE__ */ r(
    F,
    {
      bgColor: S,
      px: u,
      py: x,
      w: g,
      borderRadius: j.Small,
      display: "flex",
      alignItems: "center",
      minHeight: d,
      fontFamily: m.Body,
      color: n,
      ...C,
      children: /* @__PURE__ */ t(l, { align: "center", w: "100%", justify: "space-between", gap: "10px", children: [
        /* @__PURE__ */ t(l, { gap: "10px", children: [
          /* @__PURE__ */ r(
            f,
            {
              color: n,
              icon: T,
              size: s.Small,
              mt: z,
              alignSelf: c
            }
          ),
          /* @__PURE__ */ t(l, { direction: "column", alignContent: "flex-start", children: [
            o && /* @__PURE__ */ r(
              R,
              {
                fontFamily: m.SubHeader,
                fontSize: w.Large,
                fontWeight: "medium",
                children: o
              }
            ),
            p
          ] })
        ] }),
        A()
      ] })
    }
  );
}
export {
  G as Alert
};
